import { Component } from '@angular/core';
import { AppComponent } from '../../app.component';
export interface TestType {
  name: string;
  value: string;
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent {

  appComponent: AppComponent;
  constructor(root: AppComponent) {
    this.appComponent = root;
  }


  login(): void {
    this.appComponent.login();
  }

}
